import React, { useEffect, useState } from 'react';
import DateView from '../DateView';

export default ({ timeStamp, format, className }) => {
    const [time, setTime] = useState(timeStamp - Date.now());
    useEffect(() => {
        const intervalId = setInterval(() => {
            setTime(timeStamp - Date.now());
        }, 1000);
        return () => clearInterval(intervalId);
    }, [timeStamp]);
    return <DateView timeStamp={Math.max(0, time)} format={format} utc={true} className={className} />;
};

